import { ofType } from "redux-observable";
import { EMPTY } from "rxjs";
import { switchMap } from "rxjs/operators";
import { TypeActionLandingPage } from "./actionLandingPage";
import { landingPageMessageHandler } from "./landingPageMessageHandler";
export var epicLandingPageLogoutConfirmation = function (action$, state$, deps) {
    return action$.pipe(ofType(TypeActionLandingPage.LogoutConfirmation), switchMap(function () {
        landingPageMessageHandler.onLogout();
        // re-enabling the possibility to connect in case the user logs off via disconnect dialog.
        deps.netEnableConnections();
        return EMPTY;
    }));
};



//////////////////
// WEBPACK FOOTER
// ./src/features/landing-page/epicLandingPageLogoutConfirmation.ts
// module id = 1982
// module chunks = 3